import React from "react";
import { SelectBox, Button, TextBox } from "devextreme-react";
import TFYPManager from "./FYPManager";
import { connect } from "react-redux";

let accessToken = "";
class FiscalYearComponent extends React.Component {
  constructor(props) {
    super(props);

    accessToken = props.oidc.user.access_token;
    this.manager = new TFYPManager(accessToken);

    this.BtnCancelClick = this.BtnCancelClick.bind(this);
    this.BtnOkClick = this.BtnOkClick.bind(this);

    this.state = {
      maxPriorPer: props?.MaxPriorPeriods ? props?.MaxPriorPeriods : 0,
      maxPriorPerInPrevYear: props?.MaxPeriodsInPriorYear ? props?.MaxPeriodsInPriorYear : 0,
      numPrevYearPer: props?.NumPrevYearPer ? props?.NumPrevYearPer : 0,
      minPeriod: props?.MinPeriod ? props?.MinPeriod : 0,
      minYear: props?.MinYear ? props?.MinYear : 0,
      maxPeriod: props?.MaxPeriod ? props?.MaxPeriod : 0,
      maxYear: props?.MaxYear ? props?.MaxYear : 0,
      postPeriod: props?.IsPostPeriod ? props?.IsPostPeriod : false,
      CurrentFiscalYear: props?.FiscalYear ? props?.FiscalYear : 0,
      CurrentFiscalPeriod: props?.FiscalPeriod ? props?.FiscalPeriod : 0,
      cbFY: [],
      cbFP: [],
      lblText: props?.lblTextHeading ? props?.lblTextHeading : "Date is out of range.",
      lblFieldLabel: props?.FieldCaption ? props?.FieldCaption : "",
      btnEnabled: false,
      selectedFY: props?.FiscalYear ? props?.FiscalYear : 0,
      selectedFP: props?.FiscalPeriod ? props?.FiscalPeriod : 0,
      edtCurrentDate: new Date().toLocaleDateString(),
      edtCurFP: props?.FiscalPeriod ? props?.FiscalPeriod : "0",
      edtCurFY: props?.FiscalYear ? props?.FiscalYear : "0",
      edtTransDate: props?.TransDate ? props?.TransDate.toLocaleDateString() : new Date().toLocaleDateString(),
    };
  }
  componentDidMount() {
    this.initYears();
  }
  BtnOkClick() {
    this.props.parentCallBackOkButton(this.state.selectedFP, this.state.selectedFY);
  }
  BtnCancelClick() {
    this.props.parentCallBackCancelButton();
  }
  initYears() {
    const { minYear, maxYear } = this.state;
    let cbFY = [];
    for (let i = minYear; i <= maxYear; i++) {
      cbFY.push(i.toString());
    }
    //const [P, Y] = await this.manager.getCurrentFiscalPeriodYear();
    let Y = this.state.CurrentFiscalYear
    this.setState({ cbFY, selectedFY: cbFY.length > 0 ? cbFY[0] : "" });
  };

  async cbFYChange() {
    let { maxPriorPer, numPrevYearPer, maxPriorPerInPrevYear, postPeriod, minYear, maxYear, maxPeriod } = this.state;
    let cbFP = [];
    //const [CFP, CFY] = await this.manager.getCurrentFiscalPeriodYear();
    let CFY = this.state.CurrentFiscalYear;
    let CFP = this.state.CurrentFiscalPeriod;

    let selectedYear = parseInt(this.state.selectedFY);

    if (selectedYear == CFY) {
      let startPeriod = Math.max(CFP - maxPriorPer, 1);
      for (let j = startPeriod; j <= CFP; j++)
        cbFP.push(j.toString());
      let topPeriod = maxYear > CFY ? await this.manager.getPeriodsNum(CFY) : maxPeriod;
      for (let j = CFP + 1; j <= topPeriod; j++)
        cbFP.push(j.toString());
    }
    if (selectedYear < CFY) {
      if (postPeriod)
        cbFP.push("99");
      else {
        let startPeriod = CFP - maxPriorPer + numPrevYearPer;
        if (startPeriod < numPrevYearPer - maxPriorPerInPrevYear)
          startPeriod = numPrevYearPer - maxPriorPerInPrevYear + 1;
        if (startPeriod < 1)
          startPeriod = 1;
        for (let j = startPeriod; j <= numPrevYearPer; j++)
          cbFP.push(j.toString());
      }
    }
    if (selectedYear > CFY) {
      let topPeriod = selectedYear == maxYear ? maxPeriod : await this.manager.getPeriodsNum(selectedYear);
      for (let j = 1; j <= topPeriod; j++)
        cbFP.push(j.toString());
    }
    this.setState({ cbFP, btnEnabled: cbFP.length > 0 && this.state.cbFY.length > 0, selectedFP: cbFP.length > 0 ? cbFP[0] : "" });
  };
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h6>{this.state.lblText}</h6>
          </div>
        </div>
        <div className="row py-2">
          <div className="col-md-2">
          </div>
          <div className="col-md-4 font-weight-bold">
            Current
          </div>
          <div className="col-md-4">
            {this.state.lblFieldLabel}
          </div>
        </div>
        <div className="row py-2">
          <div className="col-md-2 text-center mt-3">
            <span className="float-md-right font-weight-bold">Date</span>
          </div>
          <div className="col-md-4">
            <TextBox
              className="light-ui-textbox"
              value={this.state.edtCurrentDate}
              disabled={true}
            />
          </div>
          <div className="col-md-4">
            <TextBox
              className="light-ui-textbox"
              value={this.state.edtTransDate}
              disabled={true}
            />
          </div>
        </div>
        <div className="row py-2">
          <div className="col-md-2 text-center mt-3">
            <span className="float-md-right font-weight-bold">Fiscal Period</span>
          </div>
          <div className="col-md-4">
            <TextBox
              className="light-ui-textbox"
              value={this.state.edtCurFP}
              disabled={true}
            />
          </div>
          <div className="col-md-4">
            <SelectBox
              className="light-ui-textbox"
              dataSource={this.state.cbFP}
              value={this.state.selectedFP}
              onValueChanged={(e) => this.setState({ selectedFP: e.value })}
            />
          </div>
        </div>
        <div className="row py-2">
          <div className="col-md-2 text-center mt-3">
            <span className="float-md-right font-weight-bold">Fiscal Year</span>
          </div>
          <div className="col-md-4">
            <TextBox
              className="light-ui-textbox"
              value={this.state.edtCurFY}
              disabled={true}
            />
          </div>
          <div className="col-md-4">
            <SelectBox
              className="light-ui-textbox"
              dataSource={this.state.cbFY}
              value={this.state.selectedFY}
              onValueChanged={(e) => this.setState({ selectedFY: e.value }, this.cbFYChange)}
            />
          </div>
        </div>
        <div className="row py-2">
          <div className="col-md-6">
          </div>
          <div className="col-md-6">
            <Button
              text="OK"
              type="default"
              disabled={!this.state.btnEnabled}
              onClick={this.BtnOkClick}
            />
            <Button
              text="Cancel"
              className="ml-3"
              disabled={!this.state.btnEnabled}
              onClick={this.BtnCancelClick}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(FiscalYearComponent);
